/** Dias de antecedencia para o alerta de vencimento (configuravel). */
export const DEFAULT_EXPIRY_ALERT_DAYS = 3;
export const UNITS = ['un', 'kg', 'g', 'L', 'ml', 'pct', 'cx', 'dz', 'lata', 'rolo'];
export const DEFAULT_UNIT = 'un';
/**
 * Nome por extenso de cada unidade. A sigla sozinha ("dz", "pct") nao diz nada
 * a quem esta guardando compras; o seletor mostra os dois.
 */
export const UNIT_LABELS = {
    un: 'unidade',
    kg: 'quilo',
    g: 'grama',
    L: 'litro',
    ml: 'mililitro',
    pct: 'pacote',
    cx: 'caixa',
    dz: 'duzia',
    lata: 'lata',
    rolo: 'rolo',
};
/** "L — litro", pronto para a opcao do seletor. */
export function unitLabel(unit) {
    const nome = UNIT_LABELS[unit];
    return nome && nome !== unit ? `${unit} — ${nome}` : unit;
}
/**
 * Tabela inicial de validade padrao por categoria (em dias). O usuario edita em
 * Configuracoes; isto e apenas a semente do banco.
 */
export const DEFAULT_SHELF_LIFE_PRESETS = [
    { category: 'Hortifruti', days: 7 },
    { category: 'Laticinios', days: 15 },
    { category: 'Leite aberto', days: 5 },
    { category: 'Carnes resfriadas', days: 3 },
    { category: 'Congelados', days: 180 },
    { category: 'Ovos', days: 30 },
    { category: 'Paes', days: 5 },
    { category: 'Enlatados', days: 720 },
    { category: 'Graos e cereais', days: 365 },
    { category: 'Massas', days: 365 },
    { category: 'Bebidas', days: 180 },
    { category: 'Higiene', days: 730 },
    { category: 'Limpeza', days: 730 },
    { category: 'Medicamentos', days: 365 },
];
/** Dispensas criadas na primeira execucao — o usuario pode apagar todas. */
export const DEFAULT_STORAGES = [
    { name: 'Geladeira', icon: 'fridge', color: '#2f80ed' },
    { name: 'Armario da Cozinha', icon: 'cabinet', color: '#e2a03f' },
    { name: 'Despensa', icon: 'pantry', color: '#27ae60' },
    { name: 'Freezer', icon: 'freezer', color: '#56ccf2' },
    { name: 'Banheiro', icon: 'bath', color: '#9b51e0' },
    { name: 'Area de Servico', icon: 'laundry', color: '#eb5757' },
];
export const STORAGE_ICONS = [
    'fridge',
    'freezer',
    'cabinet',
    'pantry',
    'bath',
    'laundry',
    'box',
    'shelf',
    'garage',
    'pet',
];
//# sourceMappingURL=constants.js.map